const global = {
  state: {
    webSocketIns: null,
    headerBg: true,
    emailText: false,
    createText: -1,
    webSocketStatus: false
  },
  mutations: {
    SETHEADBG: (state, val) => {
      state.headerBg = val
    },
    SETSENDEMAILSUCC: (state, val) => {
      state.emailText = val
    },
    INITWEBSOCKET (state, val) {
      state.webSocketIns = val
    },
    CREATETEXT: (state, val) => {
      state.createText = val
    },
    CHANGEWEBSOCKET (state, val) {
      state.webSocketStatus = val
    }
  },
  actions: {
    createWebSocket ({ commit, state, rootState, dispatch }) {
      let ws
      if (window.location.protocol === 'https:') {
        ws = new WebSocket(`wss://${window.location.host}/rest/tool`)
      } else {
        ws = new WebSocket(`ws://${window.location.host}/rest/tool`)
      }
      commit('INITWEBSOCKET', ws)
      state.webSocketIns.onmessage = function (e) {
        const data = JSON.parse(e.data)
        switch (data.cmdid) {
          case 'send_email_rsp':
            commit('SETSENDEMAILSUCC', data.result)
            break
          case 'create_domain_rsp':
            commit('CREATETEXT', data.result)
        }
      }
      state.webSocketIns.onopen = function (e) {
        window.clearTimeout(window.timeId)
        commit('CHANGEWEBSOCKET', true)
        window.keepLiveId = window.setInterval(() => {
          dispatch('sendMessage', { cmdid: 'keep_live' })
        }, 10000)
      }
      state.webSocketIns.onclose = function (e) {
        clearInterval(window.keepLiveId)
        commit('CHANGEWEBSOCKET', false)
        window.clearInterval(window.timeId)
        ws.close()
        dispatch('createWebSocket')
      }
    },
    sendMessage ({ commit, state, rootState, dispatch }, msg) {
      msg = JSON.stringify(msg)
      try {
        state.webSocketIns.send(msg)
      } catch (err) {
        console.log(err)
        commit('CHANGEWEBSOCKET', false)
        window.clearInterval(window.timeId)
      }
    }
  }
}
export default global



// WEBPACK FOOTER //
// ./src/store/modules/global.js